// apps/web/src/features/packaging-options/queries.ts
//
// Query-key constant for the Packaging admin catalog (#1152). Mirrors
// `ROAD_OPTIONS_CATALOG_QK`. Mutations on `/packaging-options` must
// invalidate BOTH this catalog key AND `PACKAGING_OPTIONS_ACTIVE_QK`
// from `apps/web/src/features/requests/dictionarySelections.queries.ts`
// so the request-form picker reflects new values without a reload.
//
// User-cache reset: this key is wiped in
// `apps/web/src/auth/userCacheReset.ts` per the `@aiInvariant` block
// for permission-gated reference catalogs.

export const PACKAGING_OPTIONS_CATALOG_QK = ['packaging-options-catalog'] as const;
